import { createApi } from "@reduxjs/toolkit/query/react";
import { CONFIG_VARS } from "../../constants/urlConstants/configuration";
import { createBaseQuery } from "../../shared/utils/baseQuery";

const { baseUrl, apiVersion, gatewayBaseUrl, gatewayApiVersion } = CONFIG_VARS;

export const eventsMutation = createApi({
  reducerPath: "eventsMutation",
  baseQuery: createBaseQuery(baseUrl["1"], true), // Enable auth token
  endpoints: (builder) => ({
    getAllEvents: builder.mutation({
      query: (data) => ({
        url: `/${apiVersion}/events/list`,
        method: "POST",
        body: data.body,
      }),
    }),
    getAllGrades: builder.mutation({
      query: () => ({
        url: `/${apiVersion}/onboarding/student-grades`,
        method: "GET",
      }),
    }),
    searchSchools: builder.mutation({
      query: (data) => ({
        url: `/${apiVersion}/insights/search-schools?search_string=${data.searchedSchool}&page=1&limit=20`,
        method: "POST",
        body: {},
      }),
    }),
    getEventLevels: builder.mutation({
      query: (data) => ({
        url: `/${apiVersion}/events/levels/${data.eventName}`,
        method: "GET",
      }),
    }),
    getUpcomingRounds: builder.mutation({
      query: (data) => ({
        url: `/${apiVersion}/events/upcoming_rounds`,
        method: "POST",
        body: data.body,
      }),
    }),
    createEvent: builder.mutation({
      query: (data) => ({
        url: `/${apiVersion}/events`,
        method: "POST",
        body: data.body,
      }),
    }),
    deleteEvent: builder.mutation({
      query: (data) => ({
        url: `/${apiVersion}/events/${data.eventId}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useGetAllEventsMutation,
  useGetAllGradesMutation,
  useSearchSchoolsMutation,
  useGetEventLevelsMutation,
  useGetUpcomingRoundsMutation,
  useCreateEventMutation,
  useDeleteEventMutation,
} = eventsMutation;

export const userAgentsMutation = createApi({
  reducerPath: "userAgentsMutation",
  baseQuery: createBaseQuery(gatewayBaseUrl["1"], true),
  endpoints: (builder) => ({
    getUserAgents: builder.mutation({
      query: (data = {}) => ({
        url: `/${gatewayApiVersion}/user/agents`,
        method: "GET",
        params: {
          page: data.page || 1,
          limit: data.limit || 1000,
          products: data.products || 100,
          role_ids: Object.keys(CONFIG_VARS.hierarchy_role_ids[1]).join(","),
        },
      }),
      transformResponse: (response) => {
        if (response.error) {
          throw new Error(`${response.error.message}`);
        }
        return {
          agents: response.agents || [],
          totalCount: response.totalCount || 0,
          totalPages: response.totalPages || 0,
          currentPage: response.currentPage || 1,
          limit: response.limit || 10,
        };
      },
    }),
  }),
});

export const { useGetUserAgentsMutation } = userAgentsMutation;
